__turbopack_context__.v({
  "footerColumn": "DefaultFooter-module-scss-module__ObawWa__footerColumn",
  "footerRow": "DefaultFooter-module-scss-module__ObawWa__footerRow",
});
